import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/goalsSagas";
import { getGoalsHeaderConfig } from "../headerConfigs/headerConfigs";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import GoalsList from "../../../components/goalsList/goalsList";
import { AddStaff } from "./AddStaff";

const GoalSection = ({ goalType, defaultTitle, zIndex }) => {
  const dispatch = useDispatch();
  const singleLocation = useSelector((state) => state.goals.currentUser.singleLocation);
  const selectedModuleView = useSelector((state) => state.goals.selectedModuleView.id);
  const goalsLoading = useSelector((state) => state.goals.goalsLoading[goalType]);
  const visibleColumns = useSelector((state) => state.goals.visibleColumns);
  const selectedView = useSelector((state) => state.goals.selectedView.id);
  const date = useSelector((state) => state.goals.date);
  const {
    title = defaultTitle,
    goals = [],
    show_module
  } = useSelector((state) => state.goals.goals[goalType] || {});

  const goalsHeaderConfig = useMemo(
    () =>
      getGoalsHeaderConfig({ visibleColumns, selectedView, singleLocation, selectedModuleView }),
    [visibleColumns]
  );

  if (!goals.length && (!visibleColumns.showAddStaffButton || !show_module)) return null;

  return (
    <div style={{ marginTop: "7px" }}>
      <SectionToggle
        title={title}
        isLoading={goalsLoading}
        customClass={`${goalType}Goals`}
        autoHeight
        content={
          <GoalsList
            isAnimated={false}
            title={title}
            goalsHeaderContent={
              visibleColumns.showAddStaffButton && (() => <AddStaff goalType={goalType} />)
            }
            goalData={goals}
            zIndex={zIndex}
            goalsHeaderConfig={goalsHeaderConfig}
            date={date}
            visibleColumns={visibleColumns}
            singleLocation={singleLocation}
            moduleView={selectedModuleView}
            selectedView={selectedView}
            saveGoal={(id, value, active, goal_store_id) =>
              dispatch(
                actionCreators.updateGoal({
                  id: id,
                  value: value,
                  active: active,
                  goal_type: goalType,
                  goal_store_id
                })
              )
            }
            saveGoalAsValue={(id, value, active, goal_store_id) =>
              dispatch(
                actionCreators.updateGoalAsValue({
                  id: id,
                  value: value || 0,
                  active: active,
                  goal_type: goalType,
                  goal_store_id
                })
              )
            }
          />
        }
      />
    </div>
  );
};

export default GoalSection;
